<template>

<app-wrapper class="newsletter">

	<div class="newsletter-title">
		<app-icon name="newsletter" />
		<span>{{ settings.footer_newsletter_title }}</span>
	</div>

	<div class="newsletter-text">{{ settings.footer_newsletter_text }}</div>

	<div class="newsletter-input" :class="{'is-loading': is.loading, 'is-saved': is.saved, 'is-errored': is.errored}">
		<input type="text" v-model="email" :disabled="is.saved" spellcheck="false" v-on:keypress.enter="onSubmit" :placeholder="settings.footer_newsletter_placeholder" />
		<app-icon name="chevron-right" v-if="!is.saved" v-on:click="onSubmit" />
		<app-icon name="check" v-if="is.saved" />
	</div>

</app-wrapper>

</template>

<script>

export default {

	data: function() {

		return {
            is: {
                loading: false,
                saved: false,
                errored: false
            },
			email: ''
		}

    },
    
    methods: {

        onSubmit: function() {

            if (this.email && !this.is.saved) {

                this.is.loading = true
                this.is.errored = false

                this.$api.request('newsletter', {
                    email: this.email
                }).then(function() {

                    this.is.loading = false
                    this.is.saved = true

                }.bind(this), function() {

                    this.is.errored = true 
                    this.is.loading = false

                }.bind(this));

            }

        }

    }

}

</script>

<style scoped>

.newsletter {
	background-color: var(--color-blue-light);
	margin-bottom: 2px;
	flex-direction: row;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 80px 0px 24px 0px;
	background-image: url(~@/assets/logo.white.png);
	background-position: 50% 14px;
	background-size: auto 60px;
	background-repeat: no-repeat;
}

.is-mobile .newsletter {
    flex-direction: column;
}

.newsletter-title {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.newsletter-title .icon {
	color: var(--color-blue-light);
	background-color: #fff;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	line-height: 24px;
	text-align: center;
	display: block;
	margin-right: 10px;
}

.newsletter-title span {
	text-transform: uppercase;
	color: #fff;
	font-size: 14px;
}

.newsletter-text {
	text-transform: uppercase;
	color: #fff;
	font-size: 12px;
	line-height: 24px;
	padding: 0px 50px;
}

.is-mobile .newsletter-text {
    text-align: center;
    line-height: 18px;
    padding: 10px 0px;
}

.newsletter-input {
	background-color: #fff;
	height: 32px;
	width: 200px;
	display: flex;
	flex-direction: row;
	border-radius: 4px;
    transition: all 100ms linear;
}

.newsletter-input.is-errored {
    background-color: var(--color-red);
}

.newsletter-input.is-saved {
    background-color: var(--color-blue-dark);
}

.newsletter-input.is-loading {
    background-image: url('data:image/gif;base64,R0lGODlhEAALAPQAAP///wCv1Nry+NDv9ur3+gaw1ACv1C6924LX6WDM47ro8iK52UrG4IrZ6mTO5L7q8ya62gSw1E7H4Ob2+tjy9/T6/DjA3dzz+PL6/Lbn8qDg7srt9e75+wAAAAAAAAAAACH+GkNyZWF0ZWQgd2l0aCBhamF4bG9hZC5pbmZvACH5BAALAAAAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAEAALAAAFLSAgjmRpnqSgCuLKAq5AEIM4zDVw03ve27ifDgfkEYe04kDIDC5zrtYKRa2WQgAh+QQACwABACwAAAAAEAALAAAFJGBhGAVgnqhpHIeRvsDawqns0qeN5+y967tYLyicBYE7EYkYAgAh+QQACwACACwAAAAAEAALAAAFNiAgjothLOOIJAkiGgxjpGKiKMkbz7SN6zIawJcDwIK9W/HISxGBzdHTuBNOmcJVCyoUlk7CEAAh+QQACwADACwAAAAAEAALAAAFNSAgjqQIRRFUAo3jNGIkSdHqPI8Tz3V55zuaDacDyIQ+YrBH+hWPzJFzOQQaeavWi7oqnVIhACH5BAALAAQALAAAAAAQAAsAAAUyICCOZGme1rJY5kRRk7hI0mJSVUXJtF3iOl7tltsBZsNfUegjAY3I5sgFY55KqdX1GgIAIfkEAAsABQAsAAAAABAACwAABTcgII5kaZ4kcV2EqLJipmnZhWGXaOOitm2aXQ4g7P2Ct2ER4AMul00kj5g0Al8tADY2y6C+4FIIACH5BAALAAYALAAAAAAQAAsAAAUvICCOZGme5ERRk6iy7qpyHCVStA3gNa/7txxwlwv2isSacYUc+l4tADQGQ1mvpBAAIfkEAAsABwAsAAAAABAACwAABS8gII5kaZ7kRFGTqLLuqnIcJVK0DeA1r/u3HHCXC/aKxJpxhRz6Xi0ANAZDWa+kEAA7AAAAAAAAAAAA');
    background-position: 50% 50%;
    background-repeat: no-repeat;
}

.newsletter-input.is-loading > * {
    visibility: hidden;
}

.newsletter-input input {
	flex-grow: 1;
	height: 32px;
	padding: 0px 8px 0px 8px;
	font-size: 12px;
	color: var(--color-grey-dark);
    transition: all 100ms linear;
}

.newsletter-input.is-saved input,
.newsletter-input.is-errored input {
    color: #fff;
}

.newsletter-input input::placeholder {
	color: var(--color-blue-light);
	text-transform: uppercase;
}

.newsletter-input.is-errored input::placeholder {
    color: #fff;
}

.newsletter-input .icon {
	color: var(--color-blue-light);
	width: 24px;
	height: 32px;
	line-height: 32px;
    flex-shrink: 0;
	font-size: 16px;
	text-align: center;
    transition: all 100ms linear;
}

.newsletter-input.is-saved .icon,
.newsletter-input.is-errored .icon {
    color: #fff;
}

</style>